import { useState } from 'react';
import { LegalDeadlineType } from '../types/LegalCase';
import type { ErrorField } from '../types/ErrorField';
import type { AddDeadlineValue } from './useLegalCaseDeadlines';

// Campos com binding próprio na tela; qualquer outro 422 do backend cai no bloco residual.
const INLINE_FIELDS = new Set(['deadlineType', 'dueDate', 'description']);

export const residualErrors = (errorFields: ErrorField[]): ErrorField[] =>
    errorFields.filter((e) => !INLINE_FIELDS.has(e.fieldName));

interface UseLegalCaseDeadlineFormArgs {
    onSubmit: (value: AddDeadlineValue) => Promise<boolean>;
}

// Estado e handlers do formulário de prazo, fora do componente (diretriz do repo: sem
// função dentro de função). Centraliza o reset dos campos ao enviar com sucesso.
export default function useLegalCaseDeadlineForm({ onSubmit }: UseLegalCaseDeadlineFormArgs) {
    const [deadlineType, setDeadlineType] = useState<LegalDeadlineType>(LegalDeadlineType.DEFENSE);
    const [dueDate, setDueDate] = useState('');
    const [description, setDescription] = useState('');

    const reset = () => {
        setDeadlineType(LegalDeadlineType.DEFENSE);
        setDueDate('');
        setDescription('');
    };

    // A data de vencimento é obrigatória (o backend rejeita ausente com 422); só libera o
    // envio quando preenchida.
    const canSubmit = dueDate.trim().length > 0;

    const submit = async () => {
        if (!canSubmit) return;
        const ok = await onSubmit({ deadlineType, dueDate, description });
        if (ok) reset();
    };

    return {
        deadlineType, setDeadlineType,
        dueDate, setDueDate,
        description, setDescription,
        canSubmit, submit, reset,
    };
}
